import { USER_CONTEXT } from '@agilox/common';
import { Provider } from '@angular/core';
import { UserStoreService } from './user-store.service';

export function provideUserContext(): Provider[] {
	return [{ provide: USER_CONTEXT, useExisting: UserStoreService }];
}
